import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Input, Theme } from '@user-portal/wikr-components';

import { measure } from 'constants/units';

import * as S from './styled';

import { FormikInputType, InputType } from 'types/ui';

const { TALL_UNIT } = measure;

const FormikInput = ({
    values,
    errors,
    initialValues,
    setFieldTouched,
    setFieldValue,
    touched,
    field,
    type = 'text',
    label,
    unit,
    className,
    leftIcon,
    innerRef,
    rightIcon,
    dataLocator,
    placeholder,
    mb,
    successMessage,
}: FormikInputType) => {
    const [isFocus, setIsFocus] = useState(false);

    const { t } = useTranslation();

    const errorStatus = !isFocus && Boolean(errors[field] && touched[field]);

    const withoutInchLabel = unit === TALL_UNIT.imperial.in ? '' : t(label || field);

    const getFieldValue = () => {
        return values[field] ? `${values[field]}` : '';
    };

    return (
        <S.StyledWrapper $mb={mb}>
            <Input
                label={withoutInchLabel}
                name={field}
                type={type as InputType}
                value={getFieldValue()}
                unit={unit}
                placeholder={placeholder && t(placeholder)}
                errorMessage={t(errors[field] || '')}
                initialValue={`${initialValues[field]}`}
                errorStatus={errorStatus}
                successMessage={successMessage || t('successMessage.perfect')}
                onBlur={() => {
                    setIsFocus(false);
                    setFieldTouched(field);
                }}
                successStatus={!errors[field] && Boolean(touched[field])}
                onClear={() => setFieldValue(field, '')}
                className={className}
                onFocus={() => setIsFocus(true)}
                leftIcon={leftIcon}
                rightIcon={rightIcon}
                ref={innerRef}
                onChange={(e) => setFieldValue(field, e.target.value)}
                dataLocator={dataLocator}
                isFocus={isFocus}
                iconSize={20.5}
            />
        </S.StyledWrapper>
    );
};

export default FormikInput;
